import { createSlice } from '@reduxjs/toolkit';
import { getIspConnectionDetailsAsync } from './ConnectionDetailsBlockAsyncThunk';
import { buildUrl } from '../../../utilities/StringHelpers/StringHelpers';

const initialState = {
    epiData: {},
    page: 'subscribersPage',
    selectedSubscriber: null,
    internetDetails: {},
    customerServiceMessageType:'',
    isBackNavigationDone: false,
    isListenerAdded: false
};

const ConnectionDetailsBlockSlice = createSlice({
    name: 'connectionDetailsBlock',
    initialState: initialState,
    reducers: {
        resetBlock: (state) => initialState,
        initBlock: {
            reducer: (state, action) => {
                state.epiData = action.payload.epiData;
            },
            prepare(action) {
                const epiData = {
                    linkJoinToService: buildUrl(action.epiData.linkJoinToService?.value),
                }

                const payload = {
                    epiData: epiData,
                };

                return { payload: payload };
            },
        },
        goToPage: (state, action) => {
            state.page = action.payload;
            window.scrollTo(0, 0);
        },
        reportDWH: (state, action) => { },
        setSelectedSubscriber: (state, action) => {
            state.selectedSubscriber = action.payload;
        },
        setCustomerServiceMessageType: (state, action) => {
            state.customerServiceMessageType = action.payload;
        },
        setIsBackNavigationDone: (state, action) => {
            state.isBackNavigationDone = action.payload;
        },
        setIsListenerAdded: (state, action) => {
            state.isListenerAdded = action.payload;
          },
    },
    extraReducers: {
        [getIspConnectionDetailsAsync.fulfilled]: (state, action) => {
            if(!action.payload) return;
            state.internetDetails = action.payload?.internetResult;
        }

    },
});

export const {
    resetBlock,
    initBlock,
    goToPage,
    reportDWH,
    setSelectedSubscriber,
    setCustomerServiceMessageType,
    setIsBackNavigationDone,
    setIsListenerAdded
} = ConnectionDetailsBlockSlice.actions;

export default ConnectionDetailsBlockSlice.reducer;
